import { c as _c } from "react/compiler-runtime";
import { CAMPAIGNS_API } from 'modules/campaigns/api/constants';
import { CampaignStepId } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { CampaignStepViewInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-view-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { useSWRConfig } from 'swr';
interface UseCampaignStepDataInterface {
  campaignStepId?: CampaignStepId;
}
const getCampaignStepApi = (stepId: CampaignStepId) => `${CAMPAIGNS_API}/steps/${stepId}`;
export function useCampaignStepData(t0) {
  const $ = _c(10);
  const {
    campaignStepId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const {
    cache
  } = useSWRConfig();
  let t2;
  if ($[1] !== cache || $[2] !== fetcher) {
    t2 = async stepId => {
      const data = cache.get(getCampaignStepApi(stepId)) as CampaignStepViewInterface;
      if (data) {
        return data;
      } else {
        const data_0 = await fetcher(getCampaignStepApi(stepId));
        cache.set(getCampaignStepApi(stepId), data_0);
        return data_0;
      }
    };
    $[1] = cache;
    $[2] = fetcher;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const manualFetcher = t2;
  let t3;
  if ($[4] !== campaignStepId) {
    t3 = () => campaignStepId && [getCampaignStepApi(campaignStepId), RequestModuleEnum.CampaignStep];
    $[4] = campaignStepId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: campaignStepData,
    mutate: mutateCampaignStepData
  } = useControlledSwr(t3, fetcher, undefined, !!user);
  let t4;
  if ($[6] !== campaignStepData || $[7] !== manualFetcher || $[8] !== mutateCampaignStepData) {
    t4 = {
      campaignStepData,
      mutateCampaignStepData,
      manualFetcher
    };
    $[6] = campaignStepData;
    $[7] = manualFetcher;
    $[8] = mutateCampaignStepData;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}